import { api } from '../../../AxiosConfig';

class BillingAdminService {
    getOverview() {
        return api.get('/billing/admin/overview');
    }

    getPlans() {
        return api.get('/billing/plans');
    }

    getSubscription() {
        return api.get('/billing/subscription');
    }

    createCheckout(data: any) {
        return api.post('/billing/subscription/checkout', data);
    }
}

export { BillingAdminService };
